'use client';

import { useState } from 'react';

import { Modal } from '../../../Modal/Modal';
import ExportMethodSelector from './components/ExportMethodSelector';

import './styles.scss';

import { EXPORT_METHODS } from '@/components/DataIngestion/_constants/data-ingestion';

import GoogleSheetExport from './components/GoogleSheetExport/GoogleSheetExport';

export const EXPORT_JOURNEY_MODAL_SLUG = 'export-journey-modal';

const ExportJourney = () => {
  const [validExportMethod, setValidExportMethod] = useState<string>('');

  const resetExportState = () => {
    setValidExportMethod('');
  };

  const EXPORT_COMPONENT_BY_METHOD: Record<string, React.ComponentType<unknown>> = {
    [EXPORT_METHODS.GOOGLE_SHEET]: GoogleSheetExport,
  };

  const ExportComponent = EXPORT_COMPONENT_BY_METHOD[validExportMethod as keyof typeof EXPORT_COMPONENT_BY_METHOD];

  return (
    <Modal
      slug={EXPORT_JOURNEY_MODAL_SLUG}
      className="fv-export-journey-modal"
      aria-label="Export journey"
      onClose={resetExportState}
      onExited={resetExportState}
    >
      <div className="fv-export-journey-modal__content">
        {!validExportMethod && <ExportMethodSelector setValidExportMethod={setValidExportMethod} />}
        {ExportComponent && <ExportComponent />}
      </div>
    </Modal>
  );
};

export default ExportJourney;
